import React from 'react';
import './LandingPage.css';

export default function AddPrabhaag() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Add Prabhaag</h1>
      <p>Form/page to add a Prabhaag (placeholder).</p>
    </main>
  );
}
